module.exports = __webpack_public_path__ + "media/application/images/ui/email-spacer-b0086a45a9489bcd3acf4769f37b52aa.gif";